import { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { colors } from '@izettle/otto';
import { useLottie } from '../../hooks/use-lottie.js';
import { SpinnerSimple } from '../spinner-simple/index.js';
import { jsx } from 'react/jsx-runtime';
import { LoaderSize } from '../../enumerations/loader-size.js';

const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "loader__Container",
  componentId: "zettle__sc-j6hglx-0"
})(["display:flex;align-items:center;justify-content:center;", ""], _ref => {
  let {
    fullscreen
  } = _ref;
  return fullscreen ? `margin: 200px auto;` : null;
});
const StyledLottie = /*#__PURE__*/styled.div.withConfig({
  displayName: "loader__StyledLottie",
  componentId: "zettle__sc-j6hglx-1"
})(["& *{fill:", ";stroke:", ";}*{fill:", ";stroke:", ";}", ""], colors.spinner.highlight, colors.spinner.highlight, colors.spinner.highlight, colors.spinner.highlight, _ref2 => {
  let {
    size
  } = _ref2;
  switch (size) {
    case LoaderSize.Medium:
      return `
          width: 40px;
          height: 40px;
        `;
    case LoaderSize.Large:
    default:
      return `
          width: 80px;
          height: 80px;
        `;
  }
});

/**
 * @param fullscreen false by default
 * @param label optional prop that defaults to `loading spinner`.
 * @param {LoaderSize} size - Requires the LoaderSize enum. Example: ```LoaderSize.Large```.
 * or can be passed in as a string: `size='small'`
 * [More information and Examples can be found here](https://design.izettle.net/components/loader/web)
 */
const Loader = _ref3 => {
  let {
    size,
    fullscreen = false,
    label = "loading spinner"
  } = _ref3;
  const isLottiePresent = useLottie();
  const refLottie = useRef(null);
  let animation;
  useEffect(() => {
    if (!isLottiePresent) return;
    if (size !== LoaderSize.Small) {
      // @ts-ignore This component relies on the bodymovin player being present in the DOM.
      animation = window.bodymovin?.loadAnimation({
        container: refLottie.current,
        path: "https://design-cdn.zettle.com/loader/loader.json",
        autoplay: true,
        renderer: "svg",
        loop: true
      });
      return () => {
        animation?.destroy();
      };
    }
  }, [size, isLottiePresent]);
  return process.env.NODE_ENV === "test" || size === LoaderSize.Small ? /*#__PURE__*/jsx(Container, {
    fullscreen: fullscreen,
    children: /*#__PURE__*/jsx(SpinnerSimple, {
      role: "img",
      "aria-label": label,
      size: "xSmall",
      color: "highlight"
    })
  }) : /*#__PURE__*/jsx(Container, {
    fullscreen: fullscreen,
    children: /*#__PURE__*/jsx(StyledLottie, {
      role: "img",
      "aria-label": label,
      size: size,
      ref: refLottie
    })
  });
};

export { Loader };
//# sourceMappingURL=index.js.map
